
//Menu top




function preventScroll(e){
    e.preventDefault();
    e.stopPropagation();

    return false;
}

function disableScroll(){
  document.querySelector('body').addEventListener('wheel', preventScroll);
}

function enableScroll(){
    document.querySelector('body').removeEventListener('wheel', preventScroll);
}







document.querySelector('.toggle-menu input').addEventListener('click', () => {
    var menuMobile = document.querySelector('.mobile-menu');
    menuMobile.classList.toggle('show-menu');
    document.querySelector('.toggle-menu input').classList.toggle('checked');
    document.querySelector('html').classList.toggle('overflow-mobile');
    document.querySelector('body').classList.toggle('overflow-mobile');
  
  
    var input = document.querySelector('.toggle-menu input');
    if (input.classList.contains('checked')) {
        console.log('menu otwarte');
        document.querySelector('html').classList.add('overflow-mobile');
        document.querySelector('body').classList.add('overflow-mobile');
      
      } else {
        console.log('menu zamknięte');
        document.querySelector('html').classList.remove('overflow-mobile');
        document.querySelector('body').classList.remove('overflow-mobile');
      }
  });
  
//Menu scroll
  document.querySelector('.toggle-menu-fixed input').addEventListener('click', () => {
    document.querySelector('.mobile-menu-fixed').classList.toggle('show-menu');
    document.querySelector('.toggle-menu-fixed input').classList.toggle('checked');




      
    var inputMobile = document.querySelector('.toggle-menu-fixed input');
    if (inputMobile.classList.contains('checked')) {
        disableScroll()
      console.log('menu otwarte');
      document.querySelector('body').classList.add('overflow-mobile');
      document.querySelector('.mobile-menu-fixed').classList.add('overflow-mobile');
    
    } else {
        enableScroll()
      console.log('menu zamknięte');
      document.querySelector('body').classList.remove('overflow-mobile');
      document.querySelector('.mobile-menu-fixed').classList.remove('overflow-mobile');
    }


  });
  
  
  
  
  //submenu 
  const mobileItems = document.querySelectorAll('.mobile-menu .menu-item-has-children');
  mobileItems.forEach(btn => btn.addEventListener('click', btnToggle));
  
  function btnToggle(e) {
    const allItems = document.querySelectorAll('.mobile-menu .menu-item-has-children');
    const isOpenBeforeCloseAll = e.target.classList.contains("show-sub-menu");
  
    for (let i = 0; i < allItems.length; i++) {
      allItems[i].classList.remove('show-sub-menu');
      allItems[i].classList.remove('rotate');
    }
  
    if (!isOpenBeforeCloseAll) {
      e.target.classList.add('show-sub-menu');
      e.target.classList.add('rotate');
    } else {
      e.target.classList.remove('show-sub-menu');
      e.target.classList.remove('rotate');
    }
  
  }
  
  
  
  //fixed menu
  document.addEventListener("DOMContentLoaded", initFixedMenu);
  document.querySelector('.scroll-bar').style.display = "none";
  
  
  function initFixedMenu() {
    document.querySelector('.scroll-bar').style.display = "block";
  
    var currentScrollPos = window.pageYOffset;
    if (currentScrollPos > 165) {
      document.querySelector('.scroll-bar').style.top = "0";
    } else {
      document.querySelector('.scroll-bar').style.top = "-145px";
    }
  
    window.onscroll = function () {
      var menuMobile = document.querySelector('.mobile-menu-fixed');
      var currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 165) {
        document.querySelector('.scroll-bar').style.top = "0";
      } else {
  
        menuMobile.classList.remove('show-menu');
        document.querySelector('.toggle-menu-fixed input').classList.remove('checked');
        document.querySelector('.scroll-bar').style.top = "-145px";
      }
    }
  }